import React from "react";
import { Invoice } from "./invoice";
import { Panel } from "components/panel";
import { Grid } from "semantic-ui-react";
import { InvoicesForm } from "components/invoices-form";
import PopupMessage from "components/popup-message";
import { CSSTransition } from "react-transition-group";
import { formatInvoicesList } from "./invoice-list-item";
import { EntitiesList, Pagination } from "components/entities-list";

import { PaymentMethods } from "./payment-methods";

const MposInvoicesHistoryView = ({
  viewState,
  showInvoicesSearch,
  searchType,
  fromDate,
  endDate,
  invoices,
  nextPageExist,
  currentPage,
  selectedInvoice,
  permissions,
  category,
  haveParking,
  location,
  handleSearchTypeButtons,
  handleFromDate,
  handleEndDate,
  handleSubmit,
  handlePageDown,
  handlePageUp,
  handleInvoiceSelection,
  removeSelectedInvoice,
  printPage,
  downloadExcel,
  generateBill,
  showPaymentMethods,
  popupMessages,
  popupMessagesType,
  showPopup,
  closePopup,
  loadingExcel,
  loadingBill,
}) => {
  return (
    <Grid centered padded>
      <PopupMessage
        messageType={popupMessagesType}
        showPopup={showPopup}
        messages={popupMessages}
        closePopup={closePopup}
      >
        {viewState === "invoice_selection_done" && <PaymentMethods />}
      </PopupMessage>

      <Grid.Column mobile={16} tablet={14} computer={10}>
        <CSSTransition
          in={showInvoicesSearch}
          mountOnEnter
          unmountOnExit
          timeout={350}
          classNames="panel"
        >
          <Panel
            className={viewState === "invoices_search_loading" && "inactive"}
          >
            <InvoicesForm
              viewState={viewState}
              searchType={searchType}
              fromDate={fromDate}
              endDate={endDate}
              handleSearchTypeButtons={handleSearchTypeButtons}
              handleFromDate={handleFromDate}
              handleEndDate={handleEndDate}
              handleSubmit={handleSubmit}
            />
          </Panel>
        </CSSTransition>

        <CSSTransition
          in={
            (viewState === "invoices_search_done" ||
              viewState === "invoices_pagination_loading") &&
            showInvoicesSearch
          }
          mountOnEnter
          unmountOnExit
          timeout={350}
          appear={true}
          classNames="panel"
        >
          <Panel>
            <EntitiesList
              viewState={viewState}
              entities={invoices}
              formattingFunction={formatInvoicesList}
              selectionHandler={handleInvoiceSelection}
            >
              <Pagination
                padding="0 0 0.8rem 0"
                nextPageExist={nextPageExist}
                currentPage={currentPage}
                handlePageUp={handlePageUp}
                handlePageDown={handlePageDown}
              />
            </EntitiesList>
          </Panel>
        </CSSTransition>

        <CSSTransition
          in={
            viewState === "invoice_selection_done" ||
            viewState === "invoice_selection_download"
          }
          mountOnEnter
          unmountOnExit
          timeout={350}
          appear={true}
          classNames="invoice"
        >
          <Invoice
            data={selectedInvoice}
            loading={loadingExcel || loadingBill}
            category={category}
            haveParking={haveParking}
            downloadExcel={downloadExcel}
            generateBill={generateBill}
            permissions={permissions}
            removeSelectedInvoice={removeSelectedInvoice}
            printPage={printPage}
            showPaymentMethods={
              viewState === "invoice_selection_download"
                ? false
                : showPaymentMethods
            }
          />
        </CSSTransition>
      </Grid.Column>
    </Grid>
  );
};

export { MposInvoicesHistoryView };
